import { CallFailureType } from "@/types/call.types";
import { isAudioRelatedFailureMessage } from "@/utils/audio-device-storage.utils";

export const mapTwilioErrorToFailureType = (error: unknown): CallFailureType => {
    if (!error) {
        return CallFailureType.GENERIC;
    }

    let message = "";
    if (typeof error === "string") {
        message = error;
    } else if (typeof error === "object" && error !== null) {
        // @ts-expect-error Twilio errors expose message/code at runtime
        message = error.message || error.code || "";
    }

    if (typeof message !== "string") {
        return CallFailureType.GENERIC;
    }

    const msg = message.toLowerCase();
    if (msg.includes("busy")) return CallFailureType.BUSY;
    if (msg.includes("no answer")) return CallFailureType.NO_ANSWER;
    if (msg.includes("timeout")) return CallFailureType.TIMEOUT;
    if (msg.includes("network")) return CallFailureType.NETWORK_ERROR;
    if (msg.includes("invalid")) return CallFailureType.INVALID_NUMBER;
    if (msg.includes("reject")) return CallFailureType.REJECTED;
    if (isAudioRelatedFailureMessage(msg)) return CallFailureType.AUDIO_DEVICE;

    return CallFailureType.GENERIC;
};

export const mapTwilioDisconnectStatusToFailureType = (status: unknown): CallFailureType | null => {
    const statusStr = String(status);
    if (statusStr === "busy") return CallFailureType.BUSY;
    if (statusStr === "no-answer") return CallFailureType.NO_ANSWER;
    if (statusStr === "failed") return CallFailureType.GENERIC;

    return null;
};
